export const trucksHeaderElements = [
  { label: "Nombre", value: "nombre", align: "inherit" },
  { label: "Patente", value: "patente", align: "inherit" },
  { label: "tipo de pedido", value: "modulos", align: "inherit" },
  { label: "Estado", value: "estado", align: "inherit" },
];
